import { render, staticRenderFns } from "./company.children.list.vue?vue&type=template&id=1f857976&scoped=true&"
import script from "./company.children.list.vue?vue&type=script&lang=js&"
export * from "./company.children.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f857976",
  null
  
)

export default component.exports